import LANG from '@/lang/eng';

export default {
  namespaced: true,
  state: {
    storedSettings: [
      {
        id: 'browser_settings',
        desc: LANG.documentBrowserConfiguration,
        $resetMutation: 'doc/resetSettings',
        $isChangedGetter: 'doc/areSettingsChanged',
      },
      {
        id: 'media_settings',
        desc: LANG.mediaAssetManagementConfiguration,
        $resetMutation: 'mam/resetSettings',
        $isChangedGetter: 'mam/areSettingsChanged',
      },
    ],
  },
  actions: {
    resetUserSettings({ commit, state }, { id }) {
      const userSettings = state.storedSettings.find((us) => us.id === id);
      if (!userSettings) return;

      commit(userSettings.$resetMutation, null, { root: true });
    },
  },
  getters: {
    userSettings({ storedSettings }, getters, rootState, rootGetters) {
      return storedSettings.filter((us) => rootGetters[us.$isChangedGetter]);
    },
  },
};
